<template>
  <div class="fantan-number">
    <Row class="fantan-number-container">
      <div class="fantan-top">
        <div v-for="(item,index) in gameRow1" :key="index" class="fantan-top-cont">
          <new-bet-lot
            :ref="item"
            class="fantan-number-betlot"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nim))?(win_nim.includes(item)):(win_nim === item)}"
            :type="item"
            :odd="odd(oddNim)"
            :category="oddNim"
            :gameType="game"
            game="fantan-nim"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
            size="small"
          />
          <div
            :ref="`nga${item}`"
            class="fantan-number-betlotnga"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nga))?(win_nga.includes(gameRowNga1[index])):(win_nga === gameRowNga1[index])}"
          >
            <div class="fantan-number-bet-lot-title small" justify="center" align="middle">
              <span>{{gameRowNga1[index].charAt(0)}}</span>
              <span>{{gameRowNga1[index].charAt(1)}}</span>
              <span class="typecolor">{{ $t("fantan.nga") }}</span>
              <span class="typecolor">{{gameRowNga1[index].charAt(5)}}</span>
            </div>
            <Row
              class="fantan-number-bet-lot-bet-no small"
              type="flex"
              justify="center"
            >{{ odd(oddNga) }}</Row>
          </div>
        </div>
      </div>
    </Row>
    <Row class="fantan-number-container2" type="flex">
      <div class="fantan-left">
        <div v-for="(item,index) in gameRow2" :key="index" class="fantan-left-cont">
          <new-bet-lot
            :ref="item"
            class="fantan-number-betlot"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nim))?(win_nim.includes(item)):(win_nim === item)}"
            :type="item"
            :odd="odd(oddNim)"
            :category="oddNim"
            :gameType="game"
            game="fantan-nim"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
            size="small"
          />
          <div
            :ref="`nga${item}`"
            class="fantan-number-betlotnga"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nga))?(win_nga.includes(gameRowNga2[index])):(win_nga === gameRowNga2[index])}"
          >
            <div class="fantan-number-bet-lot-title small" justify="center" align="middle">
              <span>{{gameRowNga2[index].charAt(0)}}</span>
              <span>{{gameRowNga2[index].charAt(1)}}</span>
              <span class="typecolor">{{ $t("fantan.nga") }}</span>
              <span class="typecolor">{{gameRowNga2[index].charAt(5)}}</span>
            </div>
            <Row
              class="fantan-number-bet-lot-bet-no small"
              type="flex"
              justify="center"
            >{{ odd(oddNga) }}</Row>
          </div>
        </div>
      </div>

      <div class="fantan-right">
        <div v-for="(item,index) in gameRow3" :key="index" class="fantan-right-cont">
          <new-bet-lot
            :ref="item"
            class="fantan-number-betlot"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nim))?(win_nim.includes(item)):(win_nim === item)}"
            :type="item"
            :odd="odd(oddNim)"
            :category="oddNim"
            :gameType="game"
            game="fantan-nim"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
            size="small"
          />
          <div
            :ref="`nga${item}`"
            class="fantan-number-betlotnga"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nga))?(win_nga.includes(gameRowNga3[index])):(win_nga === gameRowNga3[index])}"
          >
            <div class="fantan-number-bet-lot-title small" justify="center" align="middle">
              <span>{{gameRowNga3[index].charAt(0)}}</span>
              <span>{{gameRowNga3[index].charAt(1)}}</span>
              <span class="typecolor">{{ $t("fantan.nga") }}</span>
              <span class="typecolor">{{gameRowNga3[index].charAt(5)}}</span>
            </div>
            <Row
              class="fantan-number-bet-lot-bet-no small"
              type="flex"
              justify="center"
            >{{ odd(oddNga) }}</Row>
          </div>
        </div>
      </div>
    </Row>

    <Row class="fantan-number-container">
      <div class="fantan-bottom">
        <div v-for="(item,index) in gameRow4" :key="index" class="fantan-bottom-cont">
          <new-bet-lot
            :ref="item"
            class="fantan-number-betlot"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nim))?(win_nim.includes(item)):(win_nim === item)}"
            :type="item"
            :odd="odd(oddNim)"
            :category="oddNim"
            :gameType="game"
            game="fantan-nim"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(item)"
            @update-session-storage="onUpdateSessionStorage"
            size="small"
          />
          <div
            :ref="`nga${item}`"
            class="fantan-number-betlotnga"
            :class="{'fantan-number-betlot-active':(Array.isArray(win_nga))?(win_nga.includes(gameRowNga4[index])):(win_nga === gameRowNga4[index])}"
          >
            <div class="fantan-number-bet-lot-title small" justify="center" align="middle">
              <span>{{gameRowNga4[index].charAt(0)}}</span>
              <span>{{gameRowNga4[index].charAt(1)}}</span>
              <span class="typecolor">{{ $t("fantan.nga") }}</span>
              <span class="typecolor">{{gameRowNga4[index].charAt(5)}}</span>
            </div>
            <Row
              class="fantan-number-bet-lot-bet-no small"
              type="flex"
              justify="center"
            >{{ odd(oddNga) }}</Row>
          </div>
        </div>
      </div>
    </Row>
    <!-- <div class="fantan-number-section-divider"></div> -->
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: [
    "winCellNo",
    "game",
    "gameData",
    "drawResult",
    "animation",
    "onTabEnd",
  ],
  components: {
    Row,
    Col,
    Button,
    NewBetLot,
  },
  data() {
    return {
      oddNim: "o4",
      oddNga: "o5",
      gameRowNga1: ["12NGA3", "14NGA3", "24NGA3"],
      gameRowNga2: ["12NGA4", "13NGA4", "23NGA4"],
      gameRowNga3: ["13NGA2", "14NGA2", "34NGA2"],
      gameRowNga4: ["23NGA1", "24NGA1", "34NGA1"],

      gameRow1: ["3NIM1", "3NIM2", "3NIM4"],
      gameRow2: ["4NIM1", "4NIM2", "4NIM3"],
      gameRow3: ["2NIM1", "2NIM3", "2NIM4"],
      gameRow4: ["1NIM2", "1NIM3", "1NIM4"],
      winCell: [],
      winCellFake: [],
    };
  },
  watch: {
    animation(newVal) {
      let vm = this;
      if (newVal) {
        let flipAry = [];
        let flipAry2 = [];
        let flipAry3 = [];
        let flipAnimation = new TimelineMax();
        let flipAnimation2 = new TimelineMax();
        let flipAnimation3 = new TimelineMax();
        let flipAnimation4 = new TimelineMax();

        // Set defaulf animation
        this.gameRow1.forEach((element) => {
          TweenLite.set(vm.$refs[`nga${element}`], { rotationY: 0 });
          TweenLite.set(vm.$refs[element][0].$el, { rotationY: -180 });
        });
        this.gameRow2.forEach((element) => {
          TweenLite.set(vm.$refs[`nga${element}`], { rotationX: 0 });
          TweenLite.set(vm.$refs[element][0].$el, { rotationX: -180 });
        });
        this.gameRow3.forEach((element) => {
          TweenLite.set(vm.$refs[`nga${element}`], { rotationX: 0 });
          TweenLite.set(vm.$refs[element][0].$el, { rotationX: -180 });
        });
        this.gameRow4.forEach((element) => {
          TweenLite.set(vm.$refs[`nga${element}`], { rotationY: 0 });
          TweenLite.set(vm.$refs[element][0].$el, { rotationY: -180 });
        });

        setTimeout(() => {
          //Top animation
          for (let i = this.gameRow1.length - 1; i >= 0; i--) {
            flipAnimation
              .to(vm.$refs[`nga${vm.gameRow1[i]}`], 0.1, { rotationY: 180 })
              .to(vm.$refs[vm.gameRow1[i]][0].$el, 0.1, {
                rotationY: 0,
                onComplete: function () {
                  TweenLite.set(vm.$refs[`nga${vm.gameRow1[i]}`], {
                    clearProps: "all",
                  });
                  TweenLite.set(vm.$refs[vm.gameRow1[i]][0].$el, {
                    clearProps: "all",
                  });
                },
              });

            flipAry.push(flipAnimation);
          }

          // Bottom animation
          for (let i = 0; i < this.gameRow4.length; i++) {
            flipAnimation3
              .to(vm.$refs[`nga${vm.gameRow4[i]}`], 0.1, { rotationY: 180 })
              .to(vm.$refs[vm.gameRow4[i]][0].$el, 0.1, {
                rotationY: 0,
                onComplete: function () {
                  TweenLite.set(vm.$refs[`nga${vm.gameRow4[i]}`], {
                    clearProps: "all",
                  });
                  TweenLite.set(vm.$refs[vm.gameRow4[i]][0].$el, {
                    clearProps: "all",
                  });
                },
              });

            flipAry2.push(flipAnimation3);
          }

          // Left animation
          flipAry[vm.gameRow1.length - 1].eventCallback("onComplete", () => {
            for (let i = 0; i < vm.gameRow2.length; i++) {
              flipAnimation2
                .to(vm.$refs[`nga${vm.gameRow2[i]}`], 0.1, { rotationX: 180 })
                .to(vm.$refs[vm.gameRow2[i]][0].$el, 0.1, {
                  rotationX: 0,
                  onComplete: function () {
                    TweenLite.set(vm.$refs[`nga${vm.gameRow2[i]}`], {
                      clearProps: "all",
                    });
                    TweenLite.set(vm.$refs[vm.gameRow2[i]][0].$el, {
                      clearProps: "all",
                    });
                  },
                });
            }
          });

          // Right animation
          flipAry2[vm.gameRow3.length - 1].eventCallback("onComplete", () => {
            for (let i = vm.gameRow3.length - 1; i >= 0; i--) {
              flipAnimation4
                .to(vm.$refs[`nga${vm.gameRow3[i]}`], 0.1, { rotationX: 180 })
                .to(vm.$refs[vm.gameRow3[i]][0].$el, 0.1, {
                  rotationX: 0,
                  onComplete: function () {
                    TweenLite.set(vm.$refs[`nga${vm.gameRow3[i]}`], {
                      clearProps: "all",
                    });
                    TweenLite.set(vm.$refs[vm.gameRow3[i]][0].$el, {
                      clearProps: "all",
                    });
                  },
                });
              flipAry3.push(flipAnimation4);
            }

            flipAry3[vm.gameRow3.length - 1].eventCallback("onComplete", () => {
              vm.tabEnd();
            });
          });
        }, 300);
      }
    },
  },
  computed: {
    win_nga() {
      this.winCellFake = [];
      for (let i = 0; i < this.gameRowNga1.length; i++) {
        if (this.drawResult[this.gameRowNga1[i]] == "1") {
          this.winCellFake.push(this.gameRowNga1[i]);
        }
      }

      for (let i = 0; i < this.gameRowNga2.length; i++) {
        if (this.drawResult[this.gameRowNga2[i]] == "1") {
          this.winCellFake.push(this.gameRowNga2[i]);
        }
      }

      for (let i = 0; i < this.gameRowNga3.length; i++) {
        if (this.drawResult[this.gameRowNga3[i]] == "1") {
          this.winCellFake.push(this.gameRowNga3[i]);
        }
      }

      for (let i = 0; i < this.gameRowNga4.length; i++) {
        if (this.drawResult[this.gameRowNga4[i]] == "1") {
          this.winCellFake.push(this.gameRowNga4[i]);
        }
      }
      return this.winCellFake;
    },
    win_nim() {
      this.winCell = [];
      for (let i = 0; i < this.gameRow1.length; i++) {
        if (this.drawResult[this.gameRow1[i]] == "1") {
          this.winCell.push(this.gameRow1[i]);
        }
      }

      for (let i = 0; i < this.gameRow2.length; i++) {
        if (this.drawResult[this.gameRow2[i]] == "1") {
          this.winCell.push(this.gameRow2[i]);
        }
      }

      for (let i = 0; i < this.gameRow3.length; i++) {
        if (this.drawResult[this.gameRow3[i]] == "1") {
          this.winCell.push(this.gameRow3[i]);
        }
      }

      for (let i = 0; i < this.gameRow4.length; i++) {
        if (this.drawResult[this.gameRow4[i]] == "1") {
          this.winCell.push(this.gameRow4[i]);
        }
      }
      return this.winCell;
    },
  },
  mounted() {},
  methods: {
    tabEnd() {
      this.$emit("on-tab-end");
    },
  },
};
</script>

<style lang="scss" scoped>
.fantan-number {
  // @extend .game-section;
  background: #000000;
  padding: 0;
}

.fantan-number-section-divider {
  height: 5px;
}

.fantan-number-container {
  // height: 73px;
  width: 50%;
  margin: auto;
}

.fantan-number-container .fantan-top,
.fantan-number-container .fantan-bottom {
  display: flex;
  justify-content: space-evenly;
  height: 73px;
}
.fantan-top-cont,
.fantan-bottom-cont {
  // flex: 0 0 32%;
  flex: 1 0 32%;

  position: relative;
  // margin: 2px 0 2px 1px;
  margin: 2px 1px 2px 1px;

}
.fantan-number-container .fantan-left {
  display: flex;
}
.fantan-left-cont,
.fantan-right-cont {
  position: relative;
  height: 43px;
  width: 97%;
  margin: 1px auto 0;
}

.fantan-number-container .fantan-top .fantan-number-betlot,
.fantan-number-container .fantan-top .fantan-number-betlotnga {
  // border: 1px solid #f9cb62;
  border-radius: 10px;
  height: 100%;
  // width: 99%;
  width: 100%;

  position: absolute;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;

  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 
}
.fantan-number-container .fantan-top .fantan-number-betlotnga,
.fantan-number-container .fantan-bottom .fantan-number-betlotnga {
  transform: rotateY(180deg);
}

.fantan-number-container .fantan-bottom .fantan-number-betlot,
.fantan-number-container .fantan-bottom .fantan-number-betlotnga {
  // border: 1px solid #c9c9c9;
  border-radius: 10px;
  // width: 99%;
  width: 100%;

  height: 100%;
  position: absolute;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 

}

.fantan-number-container2 .fantan-left .fantan-number-betlot,
.fantan-number-container2 .fantan-left .fantan-number-betlotnga {
  // border: 1px solid #fa4358;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  position: absolute;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%); 
}
.fantan-number-container2 .fantan-left .fantan-number-betlotnga,
.fantan-number-container2 .fantan-right .fantan-number-betlotnga {
  transform: rotateX(180deg);
}
.fantan-number-container2 .fantan-right .fantan-number-betlot,
.fantan-number-container2 .fantan-right .fantan-number-betlotnga {
  // border: 1px solid #16cc86;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  position: absolute;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%); 

}

.fantan-number-betlot-active {
  background: #6221f4 !important;
  // border: 1px solid rgba(255,255,255,0.5) !important;

  // background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 
}

.fantan-number-container2 {
  justify-content: space-between;
  // height: 44px;
}

.fantan-left,
.fantan-right {
  width: 25%;
}

.fantan-number-betlot {
  position: relative;
  // flex: 1;
  // margin: 0 2px;
  cursor: pointer; //1017 ADDED
}

.fantan-number-betlot:first-of-type {
  margin-left: unset;
}

.fantan-number-betlot:last-of-type {
  margin-right: unset;
}

.fantan-number-cell {
  position: relative;
  padding: 0;
  flex: 3.42857143;
  padding-top: 6px;
  padding-bottom: 6px;
}

.fantan-number-cell:first-of-type {
  margin-left: unset;
}

.fantan-number-cell:last-of-type {
  margin-right: unset;
}

.fantan-number-title {
  @extend .tai-xiu-game-title;
}

.fantan-number-bet-no {
  @extend .tai-xiu-game-bet-no;
  margin-top: unset;
}

.fantan-number-cell.ivu-btn:before {
  content: "";
  display: block;
  top: 0;
  height: 31%;
  z-index: 0;
}
.fantan-number-bet-lot-title {
  font-family: "Oswald";
  color: #fbfbfb;
  // text-transform: uppercase;
  font-weight: bold;
  margin: auto;
  font-size: 14px;
  // padding: 2px 0px 0 0;
}
.fantan-top .fantan-number-bet-lot-title,
.fantan-bottom .fantan-number-bet-lot-title {
  padding: 16px 0 0;
}
.fantan-number-bet-lot-bet-no {
  // @extend .tai-xiu-game-bet-no;
  font-family: "Oswald";
  color: #ffffff;
  font-weight: bold;
  margin: auto;
  font-size: 12px;
  height: 20%;
}
.typecolor {
  color: #fa4358;
}

@media only screen and (max-width: 360px) {
  .fantan-number-bet-no {
    margin-top: 5px;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.fantan-number-cell.ivu-btn {
  @extend .tai-xiu-game-btn;
}

.fantan-number-cell.ivu-btn:hover .fantan-number-title,
.fantan-number-cell.ivu-btn:hover .fantan-number-bet-no {
  @extend .tai-xiu-game-btn-hover-cell;
}

.fantan-number-cell.ivu-btn:focus {
  @extend .tai-xiu-game-btn-focus;
}

.fantan-number-cell.fantan-number-cell-active.ivu-btn .fantan-number-title,
.fantan-number-cell.fantan-number-cell-active.ivu-btn .fantan-number-bet-no {
  @extend .tai-xiu-game-btn-active;
}

.fantan-number-cell.ivu-btn:hover {
  @extend .tai-xiu-game-btn-hover;
}
</style>
